import { CommonModule, DatePipe } from "@angular/common";
import { Component, EventEmitter, Inject, Input, LOCALE_ID, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { PollInTeam, PollOccurrence } from "app/frontend/lib/polls/user-polls/user-polls.type";
import { format, getWeek } from "date-fns";
import { PollTaskDetailsOccurenceComponent } from "../poll-task-details-occurrence/poll-task-details-occurrence.component";

@Component({
    selector: "poll-task-details-occurrence-list",
    templateUrl: "./poll-task-details-occurrence-list.component.html",
    styleUrls: ["./poll-task-details-occurrence-list.component.scss"],
    imports: [
        CommonModule,
        TranslateModule,
        PollTaskDetailsOccurenceComponent
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class PollTaskDetailsOccurenceListComponent {

    protected showAll: boolean = false;

    @Input() occurrences: PollOccurrence[] = [];
    @Input() selectedOccurrence: PollOccurrence;
    @Input() pollFrequency: string;
    @Output() onSelectOccurence = new EventEmitter<PollOccurrence>();
    
    constructor(){ }

    onSelect(occurrence: PollOccurrence){
        this.onSelectOccurence.emit(occurrence);
    }
}